export const SITE_NAME = 'USFans Spreadsheet';
export const SITE_LOGO =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg';

const BASE_URL = ((import.meta.env.VITE_SITE_URL as string) || '').replace(/\/+$/, '');

export function absoluteUrl(path: string): string {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${BASE_URL}${cleanPath}`;
}

interface ArticleSchemaOptions {
  headline: string;
  description: string;
  image?: string;
  url: string;
  datePublished: string;
  dateModified: string;
}

const organization = {
  '@type': 'Organization',
  name: SITE_NAME,
  url: absoluteUrl('/'),
  logo: {
    '@type': 'ImageObject',
    url: SITE_LOGO,
  },
};

export function buildWebSiteSchema(description?: string): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: absoluteUrl('/'),
    description: description || '',
    inLanguage: ['en', 'pl', 'es', 'fr'],
    publisher: organization,
  };
}

export function buildArticleSchema(options: ArticleSchemaOptions): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: options.headline,
    description: options.description,
    image: options.image || SITE_LOGO,
    url: options.url,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': options.url,
    },
    datePublished: options.datePublished,
    dateModified: options.dateModified,
    author: organization,
    publisher: organization,
  };
}